module.exports = __webpack_public_path__ + "img/clue01.5e251831.png";